var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen bg-right bg-cover bg-gray-100"},[_c('div',{staticClass:"flex flex-col min-h-screen"},[_c('the-header'),_c('main',{staticClass:"container mx-auto ml-auto font-headline pt-32 flex-grow"},[_vm._t("default")],2),_c('the-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }